export const RETURN_PATH_PARAM = 'next';

/**
 * Accepts only same-site absolute paths.
 * Rejects absolute URLs, protocol-relative URLs ("//evil.com") and backslash
 * variants so a crafted `?next=` cannot turn the login page into an open redirect.
 */
export function sanitizeReturnPath(value: string | null | undefined): string | null {
    if (typeof value !== 'string' || value.length === 0) {
        return null;
    }

    const path = value.trim();

    if (!path.startsWith('/') || path.startsWith('//') || path.includes('\\')) {
        return null;
    }

    return path;
}

/** Appends the current location as a return path so auth screens can send the user back. */
export function withReturnPath(href: string, returnPath?: string | null): string {
    const safePath = sanitizeReturnPath(returnPath);

    if (!safePath) {
        return href;
    }

    const separator = href.includes('?') ? '&' : '?';
    return `${href}${separator}${RETURN_PATH_PARAM}=${encodeURIComponent(safePath)}`;
}

/** Destination after a successful login/confirmation, falling back to the profile. */
export function resolveReturnPath(returnPath: string | null | undefined, locale: string): string {
    return sanitizeReturnPath(returnPath) ?? `/${locale}/profile`;
}
